import { useEffect, useState } from "react";
import { KFeature } from "@WahooFitness/wsm-native/dist/esm/types/kc/KFeature";
import { useWsmPlugin } from "@/hooks/useWsmPlugin";

// KC's KFeature.APPLE_HEALTH_WORKOUT_IMPORT, which the pinned wsm-native's KFeature enum predates.
export const APPLE_HEALTH_WORKOUT_IMPORT = 2 as KFeature;

/**
 * Whether Apple Health authorization also imports the athlete's workouts from other apps. KC owns the
 * profile gate and the native app decodes it, so the answer comes through the plugin rather than remote
 * config. False until native answers, and on web.
 */
const useAppleHealthWorkoutImportEnabled = () => {
  const { sensorManagerPlugin } = useWsmPlugin();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const response = await sensorManagerPlugin.getFeatures({
          req: { features: [APPLE_HEALTH_WORKOUT_IMPORT] },
        });
        const supported = !!response?.rsp?.features?.some(
          (status) => status.feature === APPLE_HEALTH_WORKOUT_IMPORT && status.supported
        );
        if (!cancelled) {
          setEnabled(supported);
        }
      } catch {
        // No native plugin (web) means no import.
      }
    };
    check();
    return () => {
      cancelled = true;
    };
  }, [sensorManagerPlugin]);

  return { appleHealthWorkoutImportEnabled: enabled };
};

export default useAppleHealthWorkoutImportEnabled;
